import { useEffect, useRef } from "react";
import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import {msalConfig} from './authConfig'

const msalInstance = new PublicClientApplication(msalConfig);

const TokenValidator = () => {
  const lastVisibleTime = useRef(Date.now());

  // Function to validate the token
  const validateToken = async () => {
    console.log("Validating token...");
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      console.log("No user logged in, redirecting to login...");
      msalInstance.loginRedirect();
    } else {
      const silentRequest = {
        scopes: ["User.Read"], // Replace with your required scopes
        account: accounts[0],
      };

      try {
        console.log("Attempting to acquire token silently...");
        const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
        // console.log("Token acquired successfully:", tokenResponse);
      } catch (error) {
        console.error("Token validation failed:", error);
        if (error instanceof InteractionRequiredAuthError) {
          console.log("Interaction required, redirecting to login...");
          msalInstance.loginRedirect();
        } else {
          console.error("Other error:", error);
        }
      }
    }
  };

  // Function to handle page visibility change
  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      // User left the page (tab switch or minimize), record the time
      lastVisibleTime.current = Date.now();
    } else if (document.visibilityState === "visible") {
      // User returned to the page (tab switch or restore), check how long they were away
      const currentTime = Date.now();
      const timeAway = currentTime - lastVisibleTime.current;

      if (timeAway >= 30 * 60 * 1000) {
        // User was away for 30 minutes or more, validate the token
        console.log("User was away for 30 minutes or more, validating token...");
        validateToken();
      } else {
        console.log("User was away for less than 30 minutes, no validation needed.");
      }
    }
  };

  // Add event listener for page visibility change
  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null; // This component does not render anything
};

export default TokenValidator;